import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ICriterionComponent, SearchCriteriaRegistrant, SearchCriterion } from 'src/app/types/search-criteria';

@Component({
	selector: 'app-date-days-val',
	templateUrl: './date-days-val.component.html',
	styleUrls: ['./date-days-val.component.scss']
})
export class DateDaysValComponent implements OnInit {

	public days: Array<boolean | null> = [null, false, false, false, false, false, false, false];

	private default: Array<boolean | null> = [null, false, false, false, false, false, false, false];



	@Output()
	public valueChange: EventEmitter<string> = new EventEmitter<string>();

	@Input()
	public set value(val: string) {
		this.days = this.default.slice(0);
		if (!val) {
			val = '';
		}
		let values;
		if (typeof val === 'string') {
			values = val.split(',');
		} else {
			values = val;
		}
		for (const value of values) {
			this.days[value] = true;
		}
	}
	public get value(): string {
		const values = [];
		const l = this.days.length;
		for (let i = 1; i < l; i++) {
			if (this.days[i] === true) {
				values.push(i);
			}
		}
		return values.join(',');
	}

	constructor() { }
	field: string;

	ngOnInit(): void {

	}
	HandleToggle(state, target) {
		this.days[target] = state;
		this.valueChange.emit(this.value);
	}



}
